import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col } from "react-bootstrap";
import internationalBanner from "../../Images/International/prospective-international-students-banner.webp";
import opportunity from "../../Images/International/opportunity.webp";
import success from "../../Images/International/success-path.webp";
import { Link } from "react-router-dom";
import EnquiryNow from "../common/EnquiryNow";

const ProspectiveInternationalStudents = () => {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${internationalBanner})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Prospective International Students</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Prospective International Students
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Unparalleled Opportunities */}
          <Row className="align-items-center mb-5">
            <Col lg={6} className="order-lg-1 order-2">
              <div className="content-block pe-lg-4">
                <h2 className="section-title-start modern-title text-blue">
                  Unparalleled Opportunities Awaits You!
                </h2>
                <p>
                  Discover a world of opportunities at ISBM University with over
                  100 undergraduate, postgraduate, and doctoral degree programs.
                  Our esteemed faculty members, known for their excellence in
                  teaching and research, will guide you through your academic
                  journey, ensuring you receive a top-tier education that
                  prepares you for success.
                </p>
              </div>
            </Col>
            <Col lg={6} className="order-lg-2 order-1 mb-4 mb-lg-0">
              <div className="image-block rounded-3 overflow-hidden shadow-lg">
                <img
                  src={opportunity}
                  alt="Global Classroom"
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>

          {/* Global Vision */}
          <Row className="align-items-center mb-5 bg-light-blue p-4 p-lg-5 rounded-3">
            <Col lg={12} className="text-center">
              <h2 className="text-blue modern-title section-title">
                Our Global Vision
              </h2>
              <p className="lead mb-0">
                At ISBM University, our vision extends beyond borders. Through
                our globally-focused research initiatives and international
                partnerships, we aim to address global challenges and empower
                students to become effective global citizens. Step into a world
                of possibilities and embark on a transformative educational
                experience that transcends cultural boundaries.
              </p>
            </Col>
          </Row>

          {/* Path to Success */}
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="image-block rounded-3 overflow-hidden shadow-lg">
                <img src={success} alt="Campus Life" className="img-fluid" />
              </div>
            </Col>
            <Col lg={6}>
              <div className="content-block ps-lg-4">
                <h2 className="text-blue section-title-start modern-title">
                  Your Path to Success Starts Here
                </h2>
                <p>
                  With our International Partner University Program, we make it
                  seamless for you to expand your academic horizons and gain
                  invaluable international experience. Our aim is to equip you
                  with the skills and knowledge needed to thrive in an
                  interconnected world, preparing you to make a meaningful
                  impact on a global scale.
                </p>
              </div>
            </Col>
          </Row>

          {/* Embrace Diversity */}
          <Row className="mb-5">
            <Col lg={12}>
              <div className="diversity-block bg-blue text-white p-4 p-lg-5 rounded-3 text-center">
                <h2 className="modern-title section-title text-white">
                  Embrace Diversity, Explore Excellence
                </h2>
                <p className=" mb-0">
                  Experience the vibrant international community at ISBM
                  University, where students from around the world come together
                  to learn, grow, and thrive. Our commitment to diversity
                  fosters a welcoming environment where cultural exchange and
                  global perspectives are celebrated.
                </p>
              </div>
            </Col>
          </Row>

          {/* Join Family */}
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="cta-block text-center p-4 p-lg-5 rounded-3 shadow-lg border border-3 border-purple">
                <h2 className="text-blue modern-title section-title">
                  Join the ISBM University Family Today!
                </h2>
                <p className=" mb-4">
                  Come be a part of our dynamic community, where innovation
                  meets tradition, and every day brings new opportunities for
                  growth and discovery. Your journey to success begins at ISBM
                  University - where the world is your classroom, and the
                  possibilities are endless!
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <Link
                    to="/contact"
                    className="btn btn-outline-purple btn-lg px-4 py-2"
                    onClick={() => setModalShow(true)}
                  >
                    Enquire Now
                  </Link>
                  <EnquiryNow
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ProspectiveInternationalStudents;
